import React, { useState } from 'react';
import { useTask } from '../../context/TaskContext';
import TaskForm from './TaskForm';
import { FaEdit, FaTrash, FaClock, FaTag, FaCheckCircle } from 'react-icons/fa';
import { format } from 'date-fns';
import './TaskItem.css';

const TaskItem = ({ task }) => {
  const { deleteTask, updateTask } = useTask();
  const [isEditing, setIsEditing] = useState(false);

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this task?')) {
      await deleteTask(task._id);
    }
  };

  const handleStatusChange = async () => {
    const statusMap = {
      'todo': 'in-progress',
      'in-progress': 'completed',
      'completed': 'todo'
    };
    await updateTask(task._id, { ...task, status: statusMap[task.status] });
  };

  const getPriorityClass = (priority) => {
    return `priority-${priority}`;
  };

  const getStatusClass = (status) => {
    return `status-${status}`;
  };

  if (isEditing) {
    return <TaskForm taskToEdit={task} onClose={() => setIsEditing(false)} />;
  }

  return (
    <div className={`task-item card ${getStatusClass(task.status)}`}>
      <div className="task-header">
        <div className={`priority-badge ${getPriorityClass(task.priority)}`}>
          {task.priority}
        </div>
        <div className="task-actions">
          <button 
            onClick={() => setIsEditing(true)}
            className="action-btn edit-btn"
            title="Edit"
          >
            <FaEdit />
          </button>
          <button 
            onClick={handleDelete}
            className="action-btn delete-btn"
            title="Delete"
          >
            <FaTrash />
          </button>
        </div>
      </div>

      <div className="task-content">
        <h4 className="task-title">{task.title}</h4>
        {task.description && (
          <p className="task-description">{task.description}</p>
        )}
      </div>

      {task.tags && task.tags.length > 0 && (
        <div className="task-tags">
          <FaTag className="tags-icon" />
          {task.tags.map((tag, index) => (
            <span key={index} className="tag">
              {tag}
            </span>
          ))}
        </div>
      )}

      <div className="task-footer">
        {task.dueDate && (
          <div className="task-due-date">
            <FaClock />
            <span>{format(new Date(task.dueDate), 'MMM dd, yyyy')}</span>
          </div>
        )}
        
        <button 
          onClick={handleStatusChange}
          className={`status-btn ${getStatusClass(task.status)}`}
        >
          <FaCheckCircle />
          {task.status === 'todo' && 'Start'}
          {task.status === 'in-progress' && 'Complete'}
          {task.status === 'completed' && 'Reopen'}
        </button>
      </div>
    </div>
  );
};

export default TaskItem;
